import { render, staticRenderFns } from "./PageArticleList.vue?vue&type=template&id=c0d48842&"
import script from "./PageArticleList.js?vue&type=script&lang=js&"
export * from "./PageArticleList.js?vue&type=script&lang=js&"
import style0 from "./PageArticleList.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PageArticleList.lang.cs.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild%2Fthemes%2Fbase%2Fcomponents%2Fcontent%2FPageArticleList%2FPageArticleList.vue&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports